import * as Yup from 'yup';
import TextField from '@mui/material/TextField';
import Select, { getSelectOptions } from 'src/components/Select';
import RadioButtonGroup from 'src/components/RadioButtonGroup';
import { nanToUndefined } from 'src/utils';
import { SiteClusterItemField, SiteClusterProviderType } from '../types';

export const getAddClusterFormFields = (
  instanceOptions: any[] = [],
  loadingInstances = false,
  onProviderTypeChange?: (event: any) => void,
  providerType?: string
) => [
  {
    name: SiteClusterItemField.Name,
    label: 'Name',
    placeholder: 'Enter cluster name',
    Component: TextField,
    validation: Yup.string().required('Cluster name is required'),
    required: true,
  },
  {
    name: SiteClusterItemField.ProviderType,
    label: 'Provider Type',
    Component: RadioButtonGroup,
    validation: Yup.string().required('Provider type is required'),
    required: true,
    initialValue: SiteClusterProviderType.Rancher,
    onChange: onProviderTypeChange,
    options: [
      { label: 'Rancher', value: SiteClusterProviderType.Rancher },
    ],
  },
  ...(providerType
    ? [
        {
          name: SiteClusterItemField.InstanceId,
          label: 'Instance',
          placeholder: 'Select instance',
          Component: Select,
          validation: Yup.string().required('Instance is required'),
          required: true,
          options: instanceOptions,
          loading: loadingInstances,
        },
      ]
    : []),
  // Auth type is fixed to SPN by default — field hidden from user
  // {
  //   name: SiteClusterItemField.AuthType,
  //   label: 'Auth Type',
  //   Component: RadioButtonGroup,
  //   validation: Yup.string().required('Auth type is required'),
  //   required: true,
  //   defaultValue: 'SPN',
  //   options: [
  //     { label: 'SPN', value: 'SPN' },
  //     { label: 'Token', value: 'Token' },
  //   ],
  // },
];
